import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import type { ProjectStats } from '@hygge/shared';
import { Activity, Clock, FolderKanban, Users } from 'lucide-react';

interface ProjectStatsCardsProps {
  stats: ProjectStats | undefined;
  isLoading: boolean;
}

const statItems = [
  { key: 'totalProjects' as const, label: 'Total Projects', icon: FolderKanban, color: 'text-blue-600 bg-blue-500/10' },
  { key: 'activeProjects' as const, label: 'Active', icon: Activity, color: 'text-emerald-600 bg-emerald-500/10' },
  { key: 'totalMembers' as const, label: 'Members', icon: Users, color: 'text-violet-600 bg-violet-500/10' },
  { key: 'hoursMtd' as const, label: 'Hours MTD', icon: Clock, color: 'text-amber-600 bg-amber-500/10' },
];

export function ProjectStatsCards({ stats, isLoading }: ProjectStatsCardsProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {statItems.map((item) => (
          <Card key={item.key}>
            <CardContent className="p-4">
              <Skeleton className="h-4 w-20 mb-2" />
              <Skeleton className="h-7 w-12" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {statItems.map((item) => {
        const Icon = item.icon;
        const value = stats?.[item.key] ?? 0;
        return (
          <Card key={item.key}>
            <CardContent className="p-4 flex items-center gap-3">
              <div className={`flex h-9 w-9 items-center justify-center rounded-lg ${item.color}`}>
                <Icon className="h-4 w-4" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground">{item.label}</p>
                <p className="text-lg font-semibold tracking-tight">{value}</p>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
